import classnames from 'classnames/bind'
import React from 'react'

import Spinner from '~/components/Abstracts/Spinner'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type LoadingComponentProps = {
  className?: string
  color?: string
}

function LoadingComponent({ className, color }: LoadingComponentProps) {
  return (
    <section className={cx(css.LoadingComponent, className)}>
      <div className={css.spinnerContainer}>
        <Spinner className={css.spinner} color={color} />
      </div>
    </section>
  )
}

LoadingComponent.defaultProps = {}

export default LoadingComponent
